module.exports = __webpack_public_path__ + "img/interesting.cb129d77.png";